export default "__VITE_ASSET__DjyN0tNB__"